



































































import EventBus from '@/plugins/EventBus'
import { RequestMessage } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '../Store/FinanceiroStore'

@Component
export default class ModalRepassesCarregados extends Vue {
  get modalRepassesCarregados() { return this.getFinanceiroStore.modal.repassesCarregados }
  set modalRepassesCarregados(value: boolean) { this.getFinanceiroStore.setModal({ name: 'repassesCarregados', value }) }

  get headers() {
    return [
      { text: 'Grupo repasse', value: 'grupoRepasse', sortable: false, align: 'center' },
      { text: 'Fonte pagadora', value: 'fontePagadoraNome', sortable: false, align: 'center' },
      { text: 'Responsável', value: 'responsavelNome', sortable: false, align: 'center' },
      { text: 'Empresa médica', value: 'empresaMedicaNome', sortable: false, align: 'center' },
      { text: 'Valor da nota', value: 'valorNota', sortable: false, align: 'center' },
      { text: 'Situação', value: 'situacao', sortable: false, align: 'center' },
    ]
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get itens() {
    return this.getFinanceiroStore.repassesCarregados
  }

  get getPagina() {
    return this.getFinanceiroStore.paginaRepassesCarregados
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPaginaRepassesCarregados(value)
  }

  get getTotalRepassesCarregados() {
    return this.getFinanceiroStore.totalItensRepassesCarregados || 0
  }

  get repassesCarregadosLength() {
    return Math.ceil(this.getTotalRepassesCarregados / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    const id = this.getFinanceiroStore.idForDesfazerRepasse
    this.getPagina = pagina
    await this.getFinanceiroStore.getRepassesCarregados(id)
    EventBus.$emit('clearLoadingRequest')
  }

  closeModalRepassesCarregados() {
    this.getFinanceiroStore.setModal({ name: 'repassesCarregados', value: false })
  }
}
